import { RequestStatus } from "../../request";

export interface AuthenticationState {
  signInRequestState: RequestStatus;
  accountInfo: AccountInfo | null;
}

export const initialState: AuthenticationState = {
  signInRequestState: {
    isSuccessful: false,
    isFailed: false,
    isLoading: false,
  },
  accountInfo: null,
};

export function Authentication(state = initialState, action: any) {
  switch (action.type) {
    case "authentication-update-sign-in-request-state":
      return {
        ...state,
        signInRequestState: action.requestState,
      };
    case "authentication-update-account-info":
      return {
        ...state,
        accountInfo: action.accountInfo,
      };
    default:
      return state;
  }
}

export interface AccountInfo {
  mail: string;
  firstName: string;
  lastName: string;
  companyName: string;
  companyStreet: string;
  companyCity: string;
  companyPostalCode: string;
  companyCountry: string;
  companyVatId: string | null;
  apiKey: string;
  showBiddingType: boolean;
  showDetailedTargeting: boolean;
  companies: AccountInfoCompany[];
  isAdmin: boolean;
}

export interface AccountInfoCompany {
  id: string;
  companyName: string;
}
